import { Image } from '@cian/ui-kit';
import * as React from 'react';

import lockImage from './lockImage.png';

export const LockImage: React.FC = () => {
  return <Image src={lockImage} width={60} height={60} alt="lock" preloader={false} />;
};
